/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    
}
